import { EligibilityErrorCode } from '../Property'

export class SorDeterminationResponse {
  public repairAttribute: string | null = ''
  public sor: string | null = ''
  public repairContext: string | null = ''
  public errorCode: EligibilityErrorCode | null = null
}
